// Helpers for the action-flow step-2 change preview: building the "who will change" list from the
// retained selected-employee display map, and pairing each employee with its own value summary.

export const employeeDisplayName = (emp, hashId) => {
  if (emp?.label) return emp.label;

  const name = `${emp?.first_name || ''} ${emp?.last_name || ''}`.trim();
  return name || emp?.employee_number || hashId || '';
};

// Order follows `ids`. Ids missing from the map still appear (name falls back to the hash id) so the
// count and the list never diverge.
export const buildWhoList = (ids, employeesMap) => (
  (ids || []).map(hashId => {
    const emp = employeesMap?.[hashId] || null;
    return {
      hash_id: hashId,
      name: employeeDisplayName(emp, hashId),
      employee_number: emp?.label ? null : (emp?.employee_number || null),
    };
  })
);

// Add/remove toggled employees in the retained display map. Returns the same reference when nothing
// changed so React can skip re-renders. The map persists across pages so the "who" list survives
// pagination.
export const applySelectionChange = (map, employees, checked) => {
  const next = { ...(map || {}) };
  let changed = false;

  for (const emp of employees || []) {
    if (!emp?.hash_id) continue;
    if (checked) {
      next[emp.hash_id] = {
        first_name: emp.first_name,
        last_name: emp.last_name,
        employee_number: emp.employee_number,
        label: emp.label,
      };
      changed = true;
    } else if (next[emp.hash_id]) {
      delete next[emp.hash_id];
      changed = true;
    }
  }

  return changed ? next : (map || {});
};

// Pair each employee with its own what-items from whatItemsFor(hashId). Empty-valued entries are
// dropped so the summary shows only real changes.
export const pairInstanceValues = (ids, employeesMap, whatItemsFor) => (
  buildWhoList(ids, employeesMap).map(entry => ({
    ...entry,
    whatItems: (whatItemsFor(entry.hash_id) || []).filter(item => item && item.value !== '' && item.value != null),
  }))
);
